/**
 * Feature flags for the application.
 * Toggle features on/off without removing code.
 */

/** When false, hides all login, registration, and user-related UI (profile, settings, read later, personalized news, etc.) */
export const USE_USER = false;

/** App store links for mobile apps */
export const APP_LINKS = {
  ios: 'https://apps.apple.com/at/app/metagame/id6751784477',
  android: 'https://play.google.com/store/apps/details?id=news.metagame&pcampaignid=web_share',
};
